import { render } from "./App.vue?vue&type=template&id=38ea83c1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=38ea83c1&lang=scss"
script.render = render

export default script